import config from '../service/config.js'

/* eslint-disable */

//获取浏览器的宽高
function getBrowserSize() {
    return { height: window.innerHeight || document.body.clientHeight, width: window.innerWidth || document.body.clientWidth }
}

// object 转化为 查询字符串
function seriParam(paramObj, isEncode) {
    var param = ''
    var ownProperty = Object.prototype.hasOwnProperty
    for (var key in paramObj) {
        if (ownProperty.call(paramObj, key)) {
            param += key + '=' + (isEncode ? encodeURIComponent(paramObj[key]) : paramObj[key]) + '&'
        }
    }
    return param.substring(0, param.length - 1)
}

// 动态载入js
function loadScript(url, callback) {
    var script = document.createElement("script"),
        head = document.getElementsByTagName("head")[0]
    script.type = "text/javascript";
    if (script.readyState) { //IE
        script.onreadystatechange = function() {
            if (script.readyState == "loaded" || script.readyState == "complete") {
                script.onreadystatechange = null;
                head.removeChild(script)
                callback && callback();
            }
        };
    } else { //Others
        script.onload = function() {
            head.removeChild(script)
            callback && callback();
        };
    }
    script.src = url;
    head.appendChild(script);
};

// 运营位配置处理
const operationalPositionHandle = (domMap, postParam) => {
    // moongazing.min.js 为线上压缩版  在本项目 libs 文件夹下 可以找到源文件。
    loadScript('//es-static.xiaojukeji.com/static/web/public/js/moongazing.min.js', () => {
        // loadScript('//www.abiao.com/moongazing.js', () => {
        let moongazingMap = 2 // 标注接入端 2 ==> es后台
            // domMap = { bannerMin: 'new_es_admin_home_activity'}, // dom节点与推广位的对应关系
            // postParam = {} // 请求时候需要上传的参数

        window.moongazing && window.moongazing.init(moongazingMap, domMap, postParam)
    })
}

//返回带有开始日期和结束日期的对象，用于表单查询，开始日期结束日期间隔n个月
const getDateStr = (n = 3) => {
    // console.log('ppppp', n);
    let tmpobj = {}
    let dat = new Date()
    tmpobj.endstr = dat.getFullYear() + '-' + (dat.getMonth() + 1) + '-' + dat.getDate() //'2018/09/31' // dat.getFullYear()+'-'+(dat.getMonth()+1)+'-'+dat.getDate()
    dat.setMonth(dat.getMonth() - Number(n))
    tmpobj.startstr = dat.getFullYear() + '-' + (dat.getMonth() + 1) + '-' + dat.getDate() //'2016/01/01' //dat.getFullYear()+'-'+(dat.getMonth()+1)+'-'+dat.getDate()
    return tmpobj
}

//返回本月日期
const getCurrentMonth = () => {
    let tmpobj = {}
    let dat = new Date()
    tmpobj.endstr = dat.getFullYear() + '-' + (dat.getMonth() + 1) + '-' + dat.getDate() //'2018/09/31' // dat.getFullYear()+'-'+(dat.getMonth()+1)+'-'+dat.getDate()
    tmpobj.startstr = dat.getFullYear() + '-' + (dat.getMonth() + 1) + '-' + '1' //'2016/01/01' //dat.getFullYear()+'-'+(dat.getMonth()+1)+'-'+dat.getDate()
    return tmpobj
}

//时间戳转化成日期
const timestampToTime = (timestamp, getHour, getYear) => {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '年';
    var M = (date.getMonth() + 1 < 10 ? (date.getMonth() + 1) : date.getMonth() + 1) + '月';
    var D = date.getDate() + '日' + ' ';
    if (getHour) {
        var h = date.getHours() < 10 ? "0" + date.getHours() + ':' : date.getHours() + ':';
        var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m;
    } else if (getYear) {
        return Y + M + D;
    } else {
        return M + D;
    }
}

//计算字符串是否超出给定长度，如果超出返回截取之后的字符串
const Calellipsis = (text, limit) => {
    let textLength = text.replace(/[^\x00-\xff]/g, "ab").length;
    if (textLength <= limit) { //如果在给定范围内字符串直接返回字符串
        return { pop: false, text: text }
    } else {
        let str = "";
        let l = 0;
        let schar;
        for (var i = 0; schar = text.charAt(i); i++) {
            l += (schar.match(/[^\x00-\xff]/) != null ? 2 : 1);
            if (l >= limit) {
                str += "..."
                break;
            } else {
                str += schar;
            }
        }
        return { pop: true, text: str }
    }
}

// 将传入的参数重新调整，参数有值才会传给后端
const formatRequestData = (requestData) => {
    let data = {}
    for (let key in requestData) {
        if (requestData.hasOwnProperty(key) && (requestData[key] === 0 || requestData[key])) {
            data[key] = requestData[key]
        }
    }
    return data
}

// axios 下载文件，用 axios 原因是统一且不用手写地址
const downloadFileAxios = (res, fileName) => {
    if (!res) {
        return
    }
    let url = window.URL.createObjectURL(new Blob([res]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
}

/**
 * 
 * @param {*相对地址} relative_url 
 * @param {*请求参数（Object格式）} param 
 * @param {*文件名（包括文件后缀）} fileName 
 */
const download = (relative_url, param = {}, fileName = "") => {
    let a = document.createElement('a')
    let iframe
    let paramStr = ""
    for (let p in param) {
        paramStr += p + '=' + param[p] + '&'
    }
    paramStr = paramStr.length > 0 ? paramStr.substring(0, paramStr.length - 1) : paramStr
    let baseURL = config.baseURL
        // baseURL 是否以 '/' 结尾，若是，则需要去除，若不是，则不需要
    let flag = baseURL.lastIndexOf('/') === baseURL.length - 1
    let url = flag ? baseURL.substring(0, baseURL.length - 1) + relative_url : baseURL + relative_url;
    url += paramStr.length > 0 ? '?' + paramStr : paramStr
    // if (typeof a.download != "undefined") {
    //     a.href = url
    //     a.download = fileName || relative_url.substr(relative_url.lastIndexOf('/') + 1);
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(a);
    // } else {
        iframe = document.createElement('iframe')
        iframe.src = url
        document.body.appendChild(iframe)
    // }
}

//设置cookie
function setCookie(c_name, value, expiredays,domain) {
    var exdate = new Date();　　　　
    exdate.setDate(exdate.getDate() + expiredays);　　　　
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString())+( !domain ?'':';domain='+domain)+';path=/';
}

//获取cookie
function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return (arr[2]);
    else
        return null;
}

//清除cookie  
function clearCookie(name) {
    setCookie(name, "", -1,"xiaojukeji.com")
}


export {
    getBrowserSize,
    seriParam,
    loadScript,
    getDateStr,
    operationalPositionHandle,
    timestampToTime,
    Calellipsis,
    getCurrentMonth,
    formatRequestData,
    downloadFileAxios,
    download,
    setCookie,
    getCookie,
    clearCookie
}